import React, { useMemo } from 'react';
import { CircularProgress, Box } from '@material-ui/core';
import { useUserEntity } from '../../hooks/useUserEntity';
import { useCompanySlug } from '../../hooks/useCompanySlug';
import { InternalHomePage } from './InternalHomePage';
import { ExternalHomePage } from './ExternalHomePage';

export const HomePageRouter = () => {
  const userEntity = useUserEntity();
  const { companySlug, loading: companyLoading } = useCompanySlug();

  // Primary check: catalog annotation contains /external/
  const isExternalByAnnotation = useMemo(() => {
    return Boolean(
      userEntity?.value?.metadata?.annotations?.[
        'backstage.io/managed-by-location'
      ]?.includes('/external/'),
    );
  }, [userEntity?.value]);

  // Fallback: billing-portal returns a company slug for external users
  const isExternalByCompany = Boolean(companySlug);

  const isExternalUser = isExternalByAnnotation || isExternalByCompany;

  if (userEntity.loading || companyLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return isExternalUser ? <ExternalHomePage /> : <InternalHomePage />;
};
